import $ from 'jquery';
import ProductItem from '../components/ProductItem';
import FacetedFiltering from '../components/FacetedFiltering';
import RTE from '../components/RTE';

export default class StaticCollection {
  constructor(section) {
    this.el = section.el;
    this.$sortBy = $('#sort-by', this.el);
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];
    this.filtersEnabled = this.el.querySelector('[data-faceted-filter]');

    if (this.filtersEnabled) {
      this.facetedFilters = new FacetedFiltering(this.el);
    }

    for (let i = 0; i < this.productEls.length; i++) {
      this.products.push(new ProductItem(this.productEls[i]));
    }

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    this.initSort();
  }

  sortDropDown(e) {
    const { target } = e;
    const sortValue = target.value;
    if (target) {
      // Set the query string and redirect
      const queryString = new URLSearchParams(document.location.search);
      queryString.set('sort_by', sortValue);
      window.location.search = queryString;
    }
  }

  initSort() {
    this.$sortBy.on('change.sorting', this.sortDropDown.bind(this));
  }

  onSectionUnload() {
    this.products.forEach(product => product.unload());
    this.rtes.forEach(rte => rte.unload());
    this.$sortBy.off('.sorting');
    if (this.facetedFilters) {
      this.facetedFilters.unload();
    }
  }
}
